import { react2angular } from 'react2angular';

import TrainSoftwareStatusView from "./TrainSoftwareStatusView";

// TODO webtip.module is needed for React to render for some reason - move to correct module
angular.module('webtip.module')
    .component('trainSoftwareStatus', react2angular(TrainSoftwareStatusView,['isExpanded'], ['$state', 
        '$stateParams', 'TrainSoftwareStatusService', 'SyncSubscriptionService', 'userService', '__env', 'toasterService']));
